<template>
  <div class="authorizers-container">
    <v-card flat class="futuristic-card">
      <div class="card-header">
        <h1 class="text-md-center earth-color">ALL AUTHORIZERS</h1>
        <div class="title-decoration"></div>
      </div>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          placeholder="Search authorizers..."
          single-line
          hide-details
          v-model="search"
          class="futuristic-input"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="columns"
        :items="allStaff"
        :search="search"
        :rows-per-page-items="[10,25,{'text':'All','value':-1}]"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear slot="progress" color="#587e27" indeterminate height="3"></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td>{{formated_date_time(props.item.created_at)}}</td>
          <td class="font-weight-medium">{{props.item.first_name}} {{props.item.last_name}}</td>
          <td>{{props.item.department}}</td>
          <td>{{props.item.email}}</td>
          <td>{{props.item.phone_number}}</td>
          <td>{{props.item.user}}</td>
          <td>
            <v-btn depressed small @click="updateAuthorizer(props.item.public_id)" class="futuristic-btn action-btn" color="#2196f3">
              Update
            </v-btn>
            <v-btn depressed small @click="deleteAuthorizer(props.item.public_id)" class="futuristic-btn action-btn" color="#ff5252">
              Delete
            </v-btn>
          </td>
        </template>
        <template slot="footer">
          <td :colspan="columns.length" class="download-section">
            <vue-json-to-csv
              :json-data="allStaff"
              csv-title="Staff List"
              :labels="{
                first_name: { title: 'First Name'},
                last_name: { title: 'Last Name'},
                department: { title: 'Department'},
                email: { title: 'Email'},
                phone_number: { title: 'Phone Number'},
                user: { title: 'Added By'}
              }"
            >
              <v-btn class="futuristic-btn download-btn">
                <v-icon left>cloud_download</v-icon>
                Download CSV
              </v-btn>
            </vue-json-to-csv>
          </td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import VueJsonToCsv from 'vue-json-to-csv'
export default {
  name: 'all-staff',
  components: { VueJsonToCsv },
  data () {
    return {
      search: '',
      columns: [
        {
          text: 'Added On',
          value: 'created_at',
          class: "table-header"
        },
        {
          text: 'Name',
          value: 'last_name',
          class: "table-header"
        },
        {
          text: 'Department',
          value: 'department',
          class: "table-header"
        },
        {
          text: 'Email',
          value: 'email',
          class: "table-header"
        },
        {
          text: 'Phone Number',
          value: 'phone_number',
          class: "table-header"
        },
        {
          text: 'Added By',
          value: 'user',
          class: "table-header"
        },
        {
          text: 'Action',
          value: '',
          class: "table-header"
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('get_all_staffs')
  },
  methods: {
    deleteAuthorizer (publicId) {
      var data = {
        deleted_by: localStorage.getItem('lkjhgfdsa'),
        public_id: publicId
      }
      this.$store.dispatch('delete_staff', data)
    },
    updateAuthorizer (publicId) {
      this.$router.push({
        name: 'EditStaff',
        params: {
          staff_id: publicId
        }
      })
    }
  }
}
</script>

<style scoped>
.authorizers-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.authorizers-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  margin: 2px;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.action-btn {
  margin: 4px 0;
}

.download-section {
  padding: 16px;
  background: #f5f7fa;
  border-radius: 0 0 8px 8px;
}

.download-btn {
  background: linear-gradient(45deg, #587e27, #4caf50) !important;
  color: white !important;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 16px;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .authorizers-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.75rem;
  }
}

@media (max-width: 600px) {
  .authorizers-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.5rem;
  }
}
</style>